// Rôles qu'on peut affecter à une unité de soins (contrôlés aussi par be_stock).
export const ROLES_SOIGNANTS = ['ROLE_MEDECIN', 'ROLE_INFIRMIER', 'ROLE_SAGE_FEMME', 'ROLE_ADMINISTRATEUR']

export function estSoignant(personne) {
    return !!personne && (personne.roles || []).some(role => ROLES_SOIGNANTS.indexOf(role && role.nom) !== -1)
}
